import { render } from "./PaymentLiquidationsApprovalHistory.vue?vue&type=template&id=5c734f2f"
import script from "./PaymentLiquidationsApprovalHistory.vue?vue&type=script&lang=js"
export * from "./PaymentLiquidationsApprovalHistory.vue?vue&type=script&lang=js"

import "./PaymentLiquidationsApprovalHistory.vue?vue&type=style&index=0&id=5c734f2f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__